import React from "react";
var __jsx = React.createElement;
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import { CreateEditPatientReminder } from "../PatientReminder/AddEditPatientReminder";
import { t } from "i18next";
var CreateEditReminder = function CreateEditReminder(_ref) {
  var patientUid = _ref.patientUid,
    onCloseCreateEditModal = _ref.onCloseCreateEditModal,
    refetchReminders = _ref.refetchReminders,
    selectedReminder = _ref.selectedReminder;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden bg-white text-gray-800 dark:bg-gray-800 dark:text-gray-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-5 py-[7px] border-b border-gray-300 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onCloseCreateEditModal,
    className: "hover:bg-gray-100 dark:hover:bg-gray-700 px-2 -ml-2 rounded transition-colors cursor-pointer"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    size: "sm",
    className: "text-gray-600 dark:text-gray-200"
  })), /*#__PURE__*/React.createElement("span", {
    className: "flex-1 ml-3 font-medium text-base"
  }, selectedReminder !== null && selectedReminder !== void 0 && selectedReminder.id ? t("label.edit_task") : t("label.add_task"))), /*#__PURE__*/React.createElement(CreateEditPatientReminder, {
    patient_uid: patientUid,
    onCloseModal: onCloseCreateEditModal,
    selectedReminder: selectedReminder,
    refetchReminders: refetchReminders
  }));
};
export default CreateEditReminder;